import { render, staticRenderFns } from "./applyForShipment.vue?vue&type=template&id=ab01e346&scoped=true"
import script from "./applyForShipment.vue?vue&type=script&lang=js"
export * from "./applyForShipment.vue?vue&type=script&lang=js"
import style0 from "./applyForShipment.vue?vue&type=style&index=0&id=ab01e346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab01e346",
  null
  
)

export default component.exports